import { OnInit, Component} from '@angular/core';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-redaction-management',
  templateUrl: './redaction-management.component.html',
  styleUrls: ['./redaction-management.component.scss']
})
export class RedactionManagementComponent implements OnInit {
  //RedactionNewUI
  redactionMapping: boolean = false;
  redactionProfiles: boolean = false;
  aclGroup: any =  this.config.getACLGroup().settings.redaction;


  constructor(private config: AppConfig) { }

  ngOnInit() {
    console.log("comp loading")
    this.enableRedactionMapping();
  }

  enableRedactionMapping() {
    console.log("enableRedactionMapping")
    this.redactionMapping = true;
    this.redactionProfiles = false;
  }

  enableRedactionProfiles() {
    this.redactionMapping = false;
    this.redactionProfiles = true;
  }

}
